export default __webpack_public_path__ + "static/media/campaing.f13dc56a.svg";